import React from 'react'
import {
    Create,
    SimpleForm,
    TextInput,
    DateInput,
    NumberInput,
} from 'react-admin'


export const DecretoCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <NumberInput source="id" />
            <TextInput source="name" />
            <TextInput source="description" />
            <DateInput source="date" />
        </SimpleForm>
    </Create>
);
